import { IBase } from './base.interface';
import { ISchedule } from './catalog';
import { PaymentType } from './payment-method.interface';

export interface IDeliveryZoneFees {
  amount: number;
  reducedAmount?: number;
  reducedThreshold?: number;
}

export interface IDeliveryZone extends IBase {
  name: string;
  fees: IDeliveryZoneFees;
  location: {
    type: 'Polygon';
    coordinates: number[][][];
  };
  paymentTypes: PaymentType[];
  schedule: ISchedule;
  extraDeliveryTime: number;
  minPrice: number;
  disabled: boolean;
}
